import classNames from "classnames";
import { TicketListHeaderProps } from "./type";
import { useDisplayBehaviour } from "../displayBehaviour/displayBehaviourProvider";
import { useSearchParams } from "react-router-dom";
import React from "react";

export default function TicketListHeader(props: TicketListHeaderProps) {
  const { behaviour } = useDisplayBehaviour();
  const [searchParams] = useSearchParams();
  const displayChecks = React.useMemo(() => {
    return {
      canShowDescription: !!props.content && behaviour.canShowTicketPageDescriptionInRegistration(searchParams),
      canShowImage: !!props.image && behaviour.canShowTicketPageImageInRegistration(searchParams)
    };
  }, [behaviour, props.content, props.image, searchParams]);

  return (
    <section className="ticketsPageHeader">
      {(displayChecks.canShowDescription || displayChecks.canShowImage || props.title) && (
        <div
          className={classNames(
            "ticketsPageHeader_contentWrapper",
            { noTitle: !props.title },
            { noDescription: !displayChecks.canShowDescription },
            { noTicketImage: !displayChecks.canShowImage }
          )}>
          {props.title && <h1>{props.title}</h1>}
          <div className="ticketsPageHeader_body">
            {displayChecks.canShowDescription && (
              <div className={classNames("ticketsPageHeader_content", { hasTicketImage: displayChecks.canShowImage })}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: props.content || ""
                  }}></div>
              </div>
            )}
            {displayChecks.canShowImage && (
              <div className="ticketsPageHeader_image">
                <img src={props.image} alt={"logo"} />
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
